module.exports = __webpack_public_path__ + "media/images/share_hatebu-9952e8e19b70cb3580c7cff5e331ae55.svg";